import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const Error = ({ ErrorMessage }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textalign: "center",
        height: "90vh",
        width: "100vw",
        fontSize: "20px",
        fontWeight: "600",
      }}
    >
      {ErrorMessage === "loading" || !ErrorMessage ? (
        <>
          <ErrorOutlineIcon sx={{ fontSize: "15rem", color: "red" }} />
          Oops! Somthing Went Wrong....
        </>
      ) : (
        <>
          <ErrorOutlineIcon sx={{ fontSize: "15rem", color: "red" }} />
          {ErrorMessage}
        </>
      )}
    </div>
  );
};

export default Error;
